import {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useState,
} from "react";
import { fetchForm3SelectionStatus } from "../utils/form3SubjectSelection";

const StudentSubjectSelectionContext = createContext(null);

export function StudentSubjectSelectionProvider({ studentId, classId = "", children }) {
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState(null);

    const refetch = useCallback(async () => {
        if (!studentId) {
            setStatus(null);
            setLoading(false);
            return null;
        }
        setLoading(true);
        try {
            const data = await fetchForm3SelectionStatus(studentId);
            setStatus(data);
            return data;
        } catch {
            setStatus(null);
            return null;
        } finally {
            setLoading(false);
        }
    }, [studentId]);

    useEffect(() => {
        refetch();
    }, [refetch, classId]);

    const needsSelection = Boolean(status?.needsSelection && !status?.complete);

    const value = useMemo(
        () => ({ loading, status, needsSelection, refetch }),
        [loading, status, needsSelection, refetch],
    );

    return (
        <StudentSubjectSelectionContext.Provider value={value}>
            {children}
        </StudentSubjectSelectionContext.Provider>
    );
}

export function useStudentSubjectSelectionStatus() {
    const ctx = useContext(StudentSubjectSelectionContext);
    if (!ctx) {
        throw new Error(
            "useStudentSubjectSelectionStatus must be used within StudentSubjectSelectionProvider",
        );
    }
    return ctx;
}
